module.exports = __webpack_public_path__ + "static/media/biomec.af6b8d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/aranha_roja_fresa/curativa/biomec.png
// module id = 1537
// module chunks = 3